import { TFunction } from 'i18next';

export const normalizeLabelForErrorMessage = (label: string): string =>
  label
    .replaceAll('&lt;', '<')
    .replaceAll('&gt;', '>')
    .replaceAll('&nbsp;', ' ')
    .replace(/<[^>]*>/g, '')
    .replace(/\s+/g, ' ')
    .trim();

export const formatRepeatableGroupMinRowsError = (
  t: TFunction<'declaration'>,
  requiredRows: number,
  fieldLabel: string,
): string =>
  t('errors_repeatable_group_min_rows', {
    requiredRows,
    fieldLabel: normalizeLabelForErrorMessage(fieldLabel),
  });
